import i18n from '@/lang';
/* unplugin-vue-components disabled */
import { Cell as __unplugin_components_5 } from 'vant/es';
import 'vant/es/cell/style/index';
import { List as __unplugin_components_4 } from 'vant/es';
import 'vant/es/list/style/index';
import { PullRefresh as __unplugin_components_3 } from 'vant/es';
import 'vant/es/pull-refresh/style/index';
import { SwipeItem as __unplugin_components_2 } from 'vant/es';
import 'vant/es/swipe-item/style/index';
import { Swipe as __unplugin_components_1 } from 'vant/es';
import 'vant/es/swipe/style/index';
import { Search as __unplugin_components_0 } from 'vant/es';
import 'vant/es/search/style/index';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "search"
  }, [_c(__unplugin_components_0, {
    attrs: {
      "background": "none",
      "shape": "round",
      "placeholder": i18n.tc("248")
    },
    on: {
      "search": function ($event) {
        return _vm.onLoad(true);
      }
    },
    model: {
      value: _vm.seachForm.keyword,
      callback: function ($$v) {
        _vm.$set(_vm.seachForm, "keyword", $$v);
      },
      expression: "seachForm.keyword"
    }
  })], 1), _c('div', {
    staticClass: "banner"
  }, [_c(__unplugin_components_1, {
    staticClass: "my-swipe",
    attrs: {
      "autoplay": 3000,
      "indicator-color": "white",
      "lazy-render": ""
    }
  }, _vm._l(_vm.bannerList, function (item, index) {
    return _c(__unplugin_components_2, {
      key: index,
      staticClass: "item"
    }, [_c('img', {
      staticClass: "item-img",
      attrs: {
        "src": item.file_url
      }
    })]);
  }), 1)], 1), _c('div', {
    staticClass: "productList"
  }, [_vm._m(0), _c(__unplugin_components_3, {
    staticClass: "productList-item",
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: _vm.isPullLoading,
      callback: function ($$v) {
        _vm.isPullLoading = $$v;
      },
      expression: "isPullLoading"
    }
  }, [_c(__unplugin_components_4, {
    attrs: {
      "finished": _vm.upFinished,
      "immediate-check": false,
      "offset": 10,
      "finished-text": i18n.tc("275")
    },
    on: {
      "load": _vm.onLoadList
    },
    model: {
      value: _vm.loading,
      callback: function ($$v) {
        _vm.loading = $$v;
      },
      expression: "loading"
    }
  }, [_c('div', {
    staticClass: "productCont"
  }, _vm._l(_vm.list, function (item) {
    return _c(__unplugin_components_5, {
      key: item.id,
      staticClass: "item-box",
      on: {
        "click": function ($event) {
          return _vm.goDetail(item);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.goods_image,
        "alt": ""
      }
    }), _c('div', {
      staticClass: "footer"
    }, [_c('p', [_vm._v(_vm._s(item.goods_name))]), _c('div', {
      staticClass: "price"
    }, [_vm._v(" ￥ "), _c('p', [_vm._v(_vm._s(item.price))])])])]);
  }), 1)])], 1)], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v(i18n.tc("276"))])]);
}];
export { render, staticRenderFns };